










import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import ActionShowButton from '@/modules/shared/components/shared/table/action/ActionShowButton.vue'
import { AdminDepartmentRoute } from '@/modules/department/routes/admin-department.route'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {
    ActionShowButton
  }
})
export default class AdminDepartmentIndexPageTableActions extends Vue {
  constructor(
    private readonly routes: AdminDepartmentRoute
  ) {
    super()
  }

  @Prop({ required: true }) departmentId: number

  private get departmentShowPageLink() {
    return this.routes.show(this.departmentId)
  }
}
